import {
  isFinishAtType,
  isRemainingTimeType,
} from "@circle-react/helpers/paywallCustomizationHelpers";
import { type PaywallCustomization } from "@circle-react/types/PaywallCustomization";
import { addMinutes } from "date-fns";
import { useEffect, useState } from "react";

import { formatCountdownTimer } from "../helpers";

interface UseCountdownPreviewProps {
  countdownProperties: PaywallCustomization["countdown_properties"];
}

export const useCountdownPreview = ({
  countdownProperties,
}: UseCountdownPreviewProps) => {
  const { countdown_type: countdownType, finish_at: finishAt } =
    countdownProperties;
  const isFixedDate = isFinishAtType(countdownType);
  const [, setTimerTick] = useState(0);

  useEffect(() => {
    if (!isFixedDate || !finishAt) return;

    const interval = setInterval(() => setTimerTick(tick => tick + 1), 1000);
    return () => clearInterval(interval);
  }, [isFixedDate, finishAt]);

  let timeRemainingText = "";

  if (isRemainingTimeType(countdownProperties.countdown_type)) {
    timeRemainingText = formatCountdownTimer(
      addMinutes(
        new Date(),
        Number(countdownProperties.remaining_time),
      ).toISOString(),
    );
  }

  if (isFinishAtType(countdownProperties.countdown_type)) {
    timeRemainingText = formatCountdownTimer(
      countdownProperties.finish_at || new Date().toISOString(),
    );
  }

  return {
    isExpired:
      isFixedDate && finishAt ? new Date(finishAt) <= new Date() : false,
    timeRemainingText,
  };
};
